import { FilterService } from "primereact/api";

export const CONTAINS_NO_WHITESPACE = "containsNoWhitespace";

const stripWhitespace = (value: string) => value.replace(/\s+/g, "");

FilterService.register(
  CONTAINS_NO_WHITESPACE,
  (value: unknown, filter: unknown): boolean => {
    if (filter === undefined || filter === null || filter === "") return true;
    const filterStr = stripWhitespace(String(filter).toLocaleLowerCase());
    if (filterStr === "") return true;
    if (value === undefined || value === null) return false;
    return stripWhitespace(String(value).toLocaleLowerCase()).includes(filterStr);
  }
);
